<div class="my-cv-wrapper">
  <app-card>
    <div class="cv-list">
      <div *ngIf="!currentUser" class="email-title">
        <b>{{ user }} ({{email}})</b>
      </div>
      <div class="my-cv-header" *ngIf="!isNew">
        <span class="title">Vorhandene Berater CVs:</span>
        <button class="new-cv-button" mat-button color="primary" type="button" (click)="openCreateSidebar()">
          <mat-icon svgIcon="add"></mat-icon>
          <span>Neuen CV erstellen</span>
        </button>
      </div>
      <div #tableWrapper>
        <table class="cv-table" mat-table matSort [dataSource]="dataSource">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{'name' | translate}}</th>
            <td class="name-cell" mat-cell *matCellDef="let cv"> {{cv.name}} </td>
          </ng-container>
        
          <ng-container matColumnDef="language">
            <th mat-header-cell *matHeaderCellDef>{{'language' | translate}}</th>
            <td mat-cell *matCellDef="let cv"> {{cv.language}} </td>
          </ng-container>
        
          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'created_date' | translate}}</th>
            <td mat-cell *matCellDef="let cv"> {{cv.createdDate | date:'dd.MM.yyyy / HH:mm'}} </td>
          </ng-container>
        
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>{{'actions' | translate}}</th>
            <td mat-cell *matCellDef="let cv">
              <div class="buttons-row">
                <button mat-mini-fab
                        class="icon-button"
                        (click)="downloadDocX(cv)"
                        matTooltip="{{'download_cv' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="download" class="download-icon"></mat-icon>
                </button>
                <button mat-mini-fab
                        class="icon-button"
                        (click)="createNewVersion(cv.id)"
                        matTooltip="{{'add_cv_version' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="library_books" class="icon"></mat-icon>
                </button>
                <button mat-mini-fab
                        class="icon-button"
                        (click)="goToCv(cv.id, cv.language)"
                        matTooltip="{{'edit_cv' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="edit" class="icon"></mat-icon>
                </button>
                <button mat-mini-fab
                        class="icon-button"
                        (click)="removeCV(cv.id, cv.name)"
                        matTooltip="{{'remove_cv' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="delete" class="icon"></mat-icon>
                </button>
                
              </div>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator class="paginator-container" appPagination [pageSize]="pageSize" [hidePageSize]='true' showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </app-card>
</div>



